import { createFilterStopResponse } from './createFilterStopResponse';

export const filterResponse = createFilterStopResponse();
